const PETAL = "M20,4 C20,9 16,6 13,5 C5,3 0,12 0,22 C0,36 8,46 20,52 C32,46 40,36 40,22 C40,12 35,3 27,5 C24,6 20,9 20,4 Z";

const Petal = ({ w, h }) => (
  <svg viewBox="0 0 40 52" width={w} height={h} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d={PETAL} fill="currentColor" />
    {/* center vein */}
    <path d="M20,7 Q21,27 19.5,48" fill="none" stroke="rgba(255,255,255,0.42)" strokeWidth="0.9" strokeLinecap="round" />
    {/* side veins */}
    <path d="M20,19 Q12,24 7,32" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="0.7" strokeLinecap="round" />
    <path d="M20,19 Q28,24 33,32" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="0.7" strokeLinecap="round" />
  </svg>
);

const SakuraSep = () => (
  <div className="sep-sakura">
    <span className="sep-sakura-petal">
      <span className="sep-petal sep-petal-a"><Petal w={17} h={22} /></span>
      <span className="sep-petal sep-petal-b"><Petal w={23} h={30} /></span>
      <span className="sep-petal sep-petal-c"><Petal w={16} h={21} /></span>
    </span>
  </div>
);

export default SakuraSep;
